import { useMutation, useQueryClient } from '@tanstack/react-query';
import { DeleteMutationVariables, MutationArgs } from '../types';
import { cacheKeys } from './cacheKeys';
import { useFetcher } from './useFetcher';

export const useDeleteMutation = (opts: MutationArgs) => {
  const queryClient = useQueryClient();
  const listsKey = cacheKeys(opts.modelName).lists();

  const fetcherFn = useFetcher(opts.query);

  return useMutation({
    mutationFn: async (variables: DeleteMutationVariables) => {
      await fetcherFn(variables);
    },
    onSuccess: async (_data, variables) => {
      const deletedId = variables.input.id;
      queryClient.invalidateQueries({ queryKey: listsKey });
      // Drop the deleted entity's detail cache so any still-mounted consumer
      // (other tab, side panel, focus refetch) can't refetch the now-deleted
      // id and trigger a sev-3 "Cannot find" on the backend.
      queryClient.removeQueries({
        queryKey: cacheKeys(opts.modelName).detail(deletedId),
      });
      // useWorkspaceAsset keys by assetId (not workspaceAsset id), so deleting
      // an asset also leaves a stale cache under ['workspaceasset', assetId].
      if (opts.modelName === 'asset') {
        queryClient.removeQueries({ queryKey: ['workspaceasset', deletedId] });
      }
    },
  });
};
